/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'upgrade';
const componentName = 'upgrade-transcript-modal';
const prefix = `${moduleName}.${componentName}`;

export const updateLabel = `${prefix}.updateLabel`;
export const patchLabel = `${prefix}.patchLabel`;
export const rollbackLabel = `${prefix}.rollbackLabel`;
export const rollbackPatchLabel = `${prefix}.rollbackPatchLabel`;
export const headerLabel = `${prefix}.headerLabel`;
export const controllerLabel = `${prefix}.controllerLabel`;
export const successfulOperationMessage = `${prefix}.successfulOperationMessage`;
export const failedOperationMessage = `${prefix}.failedOperationMessage`;
export const nodeNameLabel = `${prefix}.nodeNameLabel`;
export const seGroupLabel = `${prefix}.seGroupLabel`;
export const transcriptLabel = `${prefix}.transcriptLabel`;
export const upgradeProgressBarDisplayValueLabel = `${prefix}.upgradeProgressBarDisplayValueLabel`;
export const upgradeProgressBarLabel = `${prefix}.upgradeProgressBarLabel`;
export const restoreProgressBarLabel = `${prefix}.restoreProgressBarLabel`;
export const completedOnLabel = `${prefix}.completedOnLabel`;
export const restoreLabel = `${prefix}.restoreLabel`;
export const dryRunLabel = `${prefix}.dryRunLabel`;
export const dryRunProgressLabel = `${prefix}.dryRunProgressLabel`;
export const goToReportLabel = `${prefix}.goToReportLabel`;

export const ENGLISH = {
    [updateLabel]: 'Update',
    [patchLabel]: 'Patch',
    [rollbackLabel]: 'Update (Rollback)',
    [rollbackPatchLabel]: 'Patch (Rollback)',
    [headerLabel]: '{0} Transcript',
    [controllerLabel]: 'Controller',
    [upgradeProgressBarLabel]: '{0} Updating to {1}',
    [restoreProgressBarLabel]: '{0} Restoring to {1}',
    [successfulOperationMessage]: 'completed successfully on {0}, view full report in Reports',
    [failedOperationMessage]: 'failed on {0}, view full report in Reports',
    [nodeNameLabel]: 'Source',
    [seGroupLabel]: 'Service Engine Group',
    [transcriptLabel]: 'Transcript',
    [upgradeProgressBarDisplayValueLabel]: 'Completed',
    [completedOnLabel]: 'Completed On',
    [restoreLabel]: 'Restore',
    [dryRunLabel]: 'Dry Run',
    [dryRunProgressLabel]: '{0} Dry Run in progress',
    [goToReportLabel]: 'Go to Report',
};
